import React, { useContext } from "react";
import { Dialog, DialogTitle, DialogContent, Typography, Button } from "@material-ui/core";

import ButtonClose from "../../../../../../../../../../util/buttonClose/.mixins/buttonClose";
import { ManageOrderContext } from "contexts/manageOrder";

export default function ModalConfirmaRecusa({ isModalOpen, handleDialogModal, actionButton }) {
    const { daysUntilDeadlineLabel } = useContext(ManageOrderContext)

    function HeaderModal() {
        return (
            <Typography
                variant="button"
                align="center"
                display="block"
                style={{ marginLeft: "20px", fontSize: "15px" }}
            >
                SUGERIR NOVA DATA ENTREGA
                <ButtonClose closeMethod={handleDialogModal} />
            </Typography>
        );
    }

    function BodyModal() {
        return (
            <div align="center">
                <Typography variant="subtitle1" align="center" gutterBottom>
                    <strong>Você tem certeza que deseja alterar data de agendamento?</strong>
                </Typography>
                {daysUntilDeadlineLabel && (
                    <Typography variant="subtitle1" align="center">
                    Um desconto é aplicado quando a entrega é alterada em {daysUntilDeadlineLabel} a data confirmada anteriormente
                    </Typography>
                    )
                }
            </div>
        );
    }

    function ButtonModal() {
        return (
            <>
                <Typography style={{ padding: "0px", margin: "25px" }} align="center">
                    <Button
                        variant="text"
                        onClick={actionButton}
                        color="primary"
                        style={{ marginRight: "20px", padding: "7.5px 20px" }}
                    >
                        SUGERIR NOVA DATA
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleDialogModal}
                        color="primary"
                        style={{ padding: "7.5px 20px" }}
                    >
                        MANTER DATA CONFIRMADA
                    </Button>
                </Typography>
            </>
        );
    }

    return (
        <Dialog open={isModalOpen} scroll="paper">
            <DialogTitle>
                <HeaderModal />
            </DialogTitle>

            <DialogContent>
                <BodyModal />
            </DialogContent>

            <ButtonModal />
        </Dialog>
    );
}
